import { observable, action } from 'mobx';

import { StoreExt } from '@utils/reactExt';

export class InsuranceClauseStore extends StoreExt {
    @observable
    visible: boolean = false;

    @action
    switchVisible = (visible: boolean = false) => {
        this.visible = visible;
    };
}

export default new InsuranceClauseStore();
